export default __webpack_public_path__ + "static/media/vf6.8ff9160f.png";